module.exports = __webpack_public_path__ + "img/symbol_5.5df32d25.png";